import React from "react";

const defaultCsrBeneficiaryData = [
  { project: "", beneficiaries: "", vulnerablePercentage: "" },
];

const CSRBeneficiariesTable = ({
  csrBeneficiaryData = defaultCsrBeneficiaryData,
  setCsrBeneficiaryData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...csrBeneficiaryData];
    updated[index][field] = value;
    setCsrBeneficiaryData(updated);
  };

  const addRow = () => {
    setCsrBeneficiaryData([
      ...csrBeneficiaryData,
      { project: "", beneficiaries: "", vulnerablePercentage: "" },
    ]);
  };

  const removeRow = () => {
    if (csrBeneficiaryData.length > 1) {
      setCsrBeneficiaryData(csrBeneficiaryData.slice(0, -1));
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    verticalAlign: "top",
    textAlign: "left",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <colgroup>
            <col style={{ width: "10%" }} />
            <col style={{ width: "30%" }} />
            <col style={{ width: "30%" }} />
            <col style={{ width: "30%" }} />
          </colgroup>
          <thead>
            <tr>
              <th style={header}>S. No</th>
              <th style={header}>CSR Project</th>
              <th style={header}>
                No. of persons benefitted from CSR Projects
              </th>
              <th style={header}>
                % of beneficiaries from vulnerable and marginalized groups
              </th>
            </tr>
          </thead>
          <tbody>
            {csrBeneficiaryData.map((row, index) => (
              <tr key={index}>
                <td
                  style={{ ...cell, textAlign: "center", fontWeight: "bold" }}
                >
                  {index + 1}.
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Name"
                    value={row.project}
                    onChange={(e) =>
                      handleChange(index, "project", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="No."
                    value={row.beneficiaries}
                    onChange={(e) =>
                      handleChange(index, "beneficiaries", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="%"
                    value={row.vulnerablePercentage}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "vulnerablePercentage",
                        e.target.value
                      )
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default CSRBeneficiariesTable;
